import { color } from "highcharts";
import Helper from "../pages/Helper";
const MomTable = ({rows}) =>{
    let myWidth = window.innerWidth;
    const cell = {
        border: "1px solid black",
        padding: "8px",
        
    };
     
    return(
        <div style={{overflowX:"scroll",padding:10}}>
        <table style={{width:myWidth}}  >
            <thead>
            <tr style={{backgroundColor:"#f8f8f8"}}>
                <td style={cell}>No</td>
                <td style={cell}>Project</td>
                <td style={cell}>Progress</td>
                <td style={cell}>Detail</td>
                <td style={cell}>Plan This Week</td>
                <td style={cell}>Target Next Week</td>
                <td style={cell}>Due Date</td>
                <td style={cell}>PIC</td>
            </tr>
            </thead>
            <tbody>
            {rows.map((item, index) => (
            <tr>
                <td style={cell}>{index + 1}</td>
                <td style={cell}>{item.project_alias}</td>
                <td style={cell}>{item.progress == null ? "" : parseFloat(item.progress).toFixed(2)}</td>
                <td style={cell}><div dangerouslySetInnerHTML={{ __html: item.detail }} /></td>
                <td style={cell}><div dangerouslySetInnerHTML={{ __html: item.plan }} /></td>
                <td style={cell}><div dangerouslySetInnerHTML={{ __html: item.target }} /></td>
                <td style={cell}>{Helper.GetDateDDMMYYYY(item.due_date)}</td>
                <td style={cell}>{item.pic}</td>
            </tr>
            ))}
            </tbody>
        </table>
        </div>
    )
}

export default MomTable